<script>
import AppDisplay from '@/components/AppDisplay.vue'
import AppModalVisualizaPdf from '@/components/AppModalVisualizaPdf.vue'
import axios from '@/utils/api'
import { v4 as uuidv4 } from 'uuid'

export default {
  components: {
    AppModalVisualizaPdf,
    AppDisplay
  },
  props: {
    despacho: {
      type: Object
    }
  },
  data () {
    return {
      bytes: null,
      arrayBytes: []
    }
  },
  methods: {
    async handleViewDocumento (documento) {
      this.bytes = await axios({
        method: 'POST',
        url: `documento/file`,
        data: {path: documento.caminho},
        responseType: 'arraybuffer'
      })
    },
    async handleViewDocumentos (documentos) {
      const b = await Promise.all(documentos.map(documento => axios({
        method: 'POST',
        url: `documento/file`,
        data: { path: documento.caminho },
        responseType: 'arraybuffer'
      })))
      this.arrayBytes = b.map(b => ({ bytes: b, id: uuidv4() }))
    }
  }
}
</script>

<template>
  <div v-if="!despacho.loading">
    <div>
      <span class="title-despacho">Dados</span>
      <hr />
    </div>
    <div class="container-despacho">
      <div>
        <div v-if="despacho.infos.includes('DOCUMENTOS') && despacho.documentos">
          <div v-for="documento in despacho.documentos.filter(documento => documento.tipo.codigo !== 'ANEXO_ANALISE')" :key="documento.id">
            <AppModalVisualizaPdf v-if="bytes" :titulo="documento.nome" :arrayBuffer="bytes" @closeModal="() => bytes = null" />
            <a class="link" @click="handleViewDocumento(documento)">{{ documento.tipo.descricao }}</a>
          </div>
        </div>
        <div v-if="despacho.infos.includes('DOCUMENTOS_ANEXOS') && despacho.documentos">
          <div>
            <AppModalVisualizaPdf v-if="arrayBytes.length" titulo="Documentos" :arrayBuffer="arrayBytes" :isMultiple="true" @closeModal="() => arrayBytes = []" />
            <a class="link" @click="handleViewDocumentos(despacho.documentos.filter(documento => documento.tipo.codigo === 'ANEXO_ANALISE'))">Anexo(s) da análise</a>
          </div>
        </div>
      </div>
      <div v-if="despacho.infos.includes('TEXTO')">
        <app-display label="Despacho:" :content="despacho.texto" :isContentInNextLine="true" />
      </div>
      <div v-if="despacho.infos.includes('ANALISTA')">
        <app-display label="Responsável:" :content="despacho.nomeAnalista" :isContentInNextLine="true" />
      </div>
      <div v-if="despacho.infos.includes('DATA')">
        <app-display label="Data:" :content="despacho.dataCadastro" :isContentInNextLine="true" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Processo/components/Despacho/Despacho.vue